'use client';

import { useEffect } from 'react';

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error('Route error boundary caught an error', {
      message: error?.message,
      digest: error?.digest,
      stack: error?.stack,
    });
  }, [error]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      }}
    >
      <div style={{ maxWidth: 680, width: '100%' }}>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Client-side exception</h1>
        <p style={{ fontSize: 14, opacity: 0.85, marginBottom: 8 }}>
          An uncaught client error occurred in this route.
        </p>
        <p style={{ fontSize: 12, opacity: 0.7, marginTop: 0, marginBottom: 16 }}>
          Error ID: {error?.digest || 'n/a'}
        </p>
        <pre
          style={{
            margin: 0,
            marginBottom: 16,
            fontSize: 12,
            padding: 12,
            borderRadius: 8,
            overflowX: 'auto',
            background: 'rgba(127,127,127,0.12)',
          }}
        >
          {error?.message || 'Unknown error'}
        </pre>
        <details style={{ marginBottom: 16 }}>
          <summary style={{ cursor: 'pointer', marginBottom: 8 }}>Technical details</summary>
          <pre
            style={{
              margin: 0,
              marginBottom: 8,
              fontSize: 12,
              padding: 12,
              borderRadius: 8,
              overflowX: 'auto',
              background: 'rgba(127,127,127,0.12)',
            }}
          >
            {error?.stack || 'No JavaScript stack available'}
          </pre>
          <pre
            style={{
              margin: 0,
              fontSize: 12,
              padding: 12,
              borderRadius: 8,
              overflowX: 'auto',
              background: 'rgba(127,127,127,0.12)',
            }}
          >
            {`URL: ${typeof window !== 'undefined' ? window.location.href : 'n/a'}\nUA: ${
              typeof navigator !== 'undefined' ? navigator.userAgent : 'n/a'
            }`}
          </pre>
        </details>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={reset}
            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #888', cursor: 'pointer' }}
          >
            Retry route
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #888', cursor: 'pointer' }}
          >
            Reload app
          </button>
        </div>
      </div>
    </div>
  );
}
